



const navbar = [
    {
        id: 1,
        mainLink : {link: '/', title: 'home'},
        subLink: [],
    },
    {
        id: 2,
        mainLink : {link: '/About-us', title: 'about'},
        subLink: [],
    },
    {
        id: 3,
        mainLink : {link: '/Website-Templates', title: 'Templates'},
        subLink: [],
    },
    {
        id: 4,
        mainLink : {link: '/Services', title: 'Services'},
        subLink: [],
    },
    {
        id: 5,
        mainLink : {link: '/Blog-grid', title: 'blogs'},
        subLink: [],
    },
];

export default navbar;